

import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'components/form/Button';
import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import { limit } from 'utils/constants';
import {
  getDataFromLocalStorage,
  getUserType,
  objectToFormData,
} from 'utils/helpers';
import { fetchNewAllEvents } from 'store/slices';
import usePermission from 'hooks/usePermission';

const AttendedEvents = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { userId } = params;
  const { eventTypeList } = useSelector((state) => ({
    eventTypeList: state.global.eventTypeList,
  }));
  const memberType = getUserType();
  const [isLoading, setIsLoading] = useState(true);
  const [tableList, setTableList] = useState([]);
  const [searchPayload, setSearchPayload] = useState({
    event_name: '',
    event_type: '',
    membership_id_or_type: '',
  });
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
    event_by_filter: '',
    user_registered_event: '1',
    user_id: userId || ''
  });

  const { viewAccess } = usePermission("Profile Management");

  const getEvents = async (obj) => {
    let forData = objectToFormData(obj);
    const response = await dispatch(fetchNewAllEvents(forData));
    // const response = await dispatch(fetchAllEvents(forData));
    setTableList(response?.data?.events || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };

  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getEvents(newData);
  };
  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getEvents(newData);
  };

  useEffect(() => {
    if (!['0', '1', '6'].includes(getDataFromLocalStorage('user_type'))) {
      navigate('/');
    }

    let newFilterData = filterData;
    let newSearchPayload = searchPayload;
    if (localStorage.filterData) {
      newFilterData = JSON.parse(localStorage.filterData);
      setSearchPayload(newFilterData);
      localStorage.removeItem('filterData');
    }
    if (localStorage.searchPayload) {
      newSearchPayload = JSON.parse(localStorage.searchPayload);
      setFilterData(newSearchPayload);
      localStorage.removeItem('searchPayload');
    }

    getEvents({ ...newFilterData, ...newSearchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);




  const header = [
    {
      isSearch: false,
      searchInputName: 'name',
      title: 'S.No',
    },
    {
      isSearch: true,
      searchInputName: 'event_name',
      title: 'Event Name',
    },
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: { options: eventTypeList, key: 'id', value: 'name' },
      searchInputName: 'event_type',
      title: 'Event Type',
    },

    {
      isSearch: false,
      searchLable: 'Action',
      title: 'Action',
    },
  ];


  const rowData = [];
  tableList.forEach((elem, index) => {
    let obj = [
      {
        value: <span>{index + 1}</span>,
      },
      {
        value: (
          <div
            className="color-7cff" //pointer

          >
            {elem.event_name}
          </div>
        ),
      },
      {
        value: elem.event_type,
      },

      {
        value: (
          <span className="action-icon-buttons">
            {viewAccess === "1" &&
              <Button
                btnStyle="light-outline"
                icon={<i className="bi bi-eye color-black-olive pointer"></i>}
                className="me-2"
                onClick={() => navigate(`/${memberType}/profile-management/profile-details/${userId}/submitted-abstracts/${elem?.id}`)}

              />
            }
          </span>
        ),
      },
    ];

    rowData.push({ data: obj });
  });


  return (
    <Card className="cps-20 cpe-20 cpt-20 cpb-10 cmt-10">
      <div className="d-flex justify-content-between align-items-center cpb-10">
        <div className="table-title">All Attended Events ({filterData?.total})</div>
      </div>
      <Table
        isLoading={isLoading}
        header={header}
        rowData={rowData}
        filterData={filterData}
        searchPayload={searchPayload}
        searchInputChange={handelChangeSearch}
        changeOffset={handelChangePagination}

      />
    </Card >
  );
};
export default AttendedEvents;
